import Isotope from 'masonry-layout';
import Blazy from 'blazy';
import './src/scss/main.scss';

import './src/js/modernizr-custom'; // custom moderniser
import './src/js/menu'; // codrops multimenu
// import './src/js/tabletop.min.js'; // codrops multimenu

// import './src/js/lory.min.js'; // lory has no npm

let bLazie;
let formats;

const publicSpreadsheetUrl = 'https://docs.google.com/spreadsheets/d/14RB8d4diDaW4SzHdgJfY-HeQYqGoNOrofoFkMYtjg3M/pubhtml?gid=0&single=true';
const brandNames = new Array('', 'http://www.220triathlon.com/', 'http://www.bikeradar.com/', 'http://www.cardmakingandpapercraft.com/magazine/cardmaking', 'http://www.cross-stitching.com/', 'http://www.classical-music.com/', 'http://www.countryfile.com/', 'http://www.deliciousmagazine.co.uk/', 'http://www.discoverwildlife.com/', 'http://www.gardensillustrated.com/', 'http://www.gardenersworld.com/', 'http://www.girltalkmagazine.com/', 'http://www.bbcgoodfood.com', 'http://www.healthyfood.co.uk/', 'http://www.hitched.co.uk/', 'http://www.historyextra.com/', 'http://www.historyrevealed.com/', 'http://www.homesandantiques.com/', 'http://www.juniormagazine.co.uk/', 'http://www.lovepatchworkandquilting.com/', 'http://www.madeformums.com/', 'http://www.molliemakes.com/', 'http://www.motdmag.com/', 'http://www.olivemagazine.com/', 'http://www.papercraftinspirationsmagazine.co.uk/', 'http://www.planyourperfectwedding.com/', 'http://www.radiotimes.com/', 'http://www.sciencefocus.com/', 'http://www.simplycrochetmag.co.uk/', 'http://www.simplysewingmag.com/', 'http://www.skyatnightmagazine.com/', 'http://www.theyarnloop.com/', 'http://www.todaysquilter.com/', 'http://www.topgear.com', 'http://www.whodoyouthinkyouaremagazine.com/', 'http://www.youandyourwedding.co.uk/');
const brandLinks = new Array('', 'http://www.220triathlon.com/', 'http://www.bikeradar.com/', 'http://www.cardmakingandpapercraft.com/magazine/cardmaking', 'http://www.cross-stitching.com/', 'http://www.classical-music.com/', 'http://www.countryfile.com/', 'http://www.deliciousmagazine.co.uk/', 'http://www.discoverwildlife.com/', 'http://www.gardensillustrated.com/', 'http://www.gardenersworld.com/', 'http://www.girltalkmagazine.com/', 'http://www.bbcgoodfood.com', 'http://www.healthyfood.co.uk/', 'http://www.hitched.co.uk/', 'http://www.historyextra.com/', 'http://www.historyrevealed.com/', 'http://www.homesandantiques.com/', 'http://www.juniormagazine.co.uk/', 'http://www.lovepatchworkandquilting.com/', 'http://www.madeformums.com/', 'http://www.molliemakes.com/', 'http://www.motdmag.com/', 'http://www.olivemagazine.com/', 'http://www.papercraftinspirationsmagazine.co.uk/', 'http://www.planyourperfectwedding.com/', 'http://www.radiotimes.com/', 'http://www.sciencefocus.com/', 'http://www.simplycrochetmag.co.uk/', 'http://www.simplysewingmag.com/', 'http://www.skyatnightmagazine.com/', 'http://www.theyarnloop.com/', 'http://www.todaysquilter.com/', 'http://www.topgear.com', 'http://www.whodoyouthinkyouaremagazine.com/', 'http://www.youandyourwedding.co.uk/');
const brandLogos = new Array('', '220-triathlon.png', 'bike-radar.png', 'cardmaking-&-papercraft.png', 'cross-stitching.png', 'classical-music.png', 'countryfile.png', 'delicious.png', 'discover-wildlife.png', 'gardens-illustrated.png', 'bbc-gardeners-world.png', 'girl-talk.png', 'BBC-good-food.png', 'healthy-food-guide.png', 'hitched.png', 'history-extra.png', 'history-revealed.png', 'homes-&-antiques.png', 'junior.png', 'love-patchwork-&-quilting.png', 'made-for-mums.png', 'mollie-makes.png', 'match-of-the-day.png', 'olive-magazine.png', 'papercraft-Inspirations.png', 'perfect-wedding.png', 'radio-times.png', 'science-focus.png', 'simply-crochet.png', 'simply-sewing.png', 'sky-at-night.png', 'the-yarn-loop.png', 'todays-quilter.png', 'BBC-top-gear.png', 'who-do-you-think-you-are.png', 'you-&-your-wedding.png');

function openMenu() {

  document.querySelector('.menu').style.display = 'block';
  document.querySelector('.action--open').style.display = 'none';
  document.querySelector('.action--close').style.display = 'block';
}

function closeMenu() {
  document.querySelector('.menu').style.display = 'none';
  document.querySelector('.action--open').style.display = 'block';
  document.querySelector('.action--close').style.display = 'none';
}

function hideMenu(ev, itemName) {
  console.log('hide menu');
}

function toggleDevice(e) {
  var t = e.target.dataset.device;

  var togs = document.getElementsByClassName('toggle');

  for (var i = 0; i < togs.length; i++) {
    togs[i].style.opacity = 0.5;
  }

  e.target.style.opacity = 1;

  switch (t) {
  case '1':
    document.querySelector('.laptop').style.display = 'none';
    document.querySelector('.tablet').style.display = 'none';
    document.querySelector('.mobile').style.display = 'block';
    document.querySelector('.video-preview').className = "video-preview";
    document.querySelector('.video-player').className = "video-player";
    break;
  case '2':
    document.querySelector('.laptop').style.display = 'none';
    document.querySelector('.tablet').style.display = 'block';
    document.querySelector('.mobile').style.display = 'none';
    document.querySelector('.video-preview').className = "video-preview";
    document.querySelector('.video-preview').classList += ' video-preview-tablet';
    document.querySelector('.video-player').className = "video-player";
    document.querySelector('.video-player').classList += ' video-preview-tablet';
    break;
  case '3':
    document.querySelector('.laptop').style.display = 'block';
    document.querySelector('.tablet').style.display = 'none';
    document.querySelector('.mobile').style.display = 'none';
    document.querySelector('.video-preview').className = "video-preview";
    document.querySelector('.video-preview').classList += ' video-preview-desktop';
    document.querySelector('.video-player').className = "video-player";
    document.querySelector('.video-player').classList += ' video-preview-desktop';
    break;
  default:
    break;
  }

}

function getNameFromUrl() {

  const path = window.location.pathname;
  const u = path.split('/').pop();
  const p = u.split('.').shift();
  const pageTitle = p.replace(/-/g, ' ');
  return pageTitle;
}

function createAvailTile(i, f) {
  let block = "<div class='cat-header'><div class='available-brand'><a href='" + brandLinks[i] + "' target='_blank'><img class='brand-logo' src='../../assets/img/specs/brand-logos/" + brandLogos[i] + "' alt='" + brandNames[i] + "'></a></div><div class='available-formats'><div class='device-icons'>";

  if (f.indexOf('D') > -1) {
    // add d
    block += "<img class='device-icon' src='../../assets/img/specs/icons/desktop_icon.png' alt='available on desktop' title='available on desktop'>";
  } else {
    block += "<img class='device-icon' src='../../assets/img/specs/icons/desktop_icon_no.png' alt='not available on desktop' title='not available on desktop'>";
  }

  if (f.indexOf('T') > -1) {
    // add d
    block += "<img class='device-icon' src='../../assets/img/specs/icons/tablet_icon.png' alt='available on tablet' title='available on tablet'>";
  } else {
    block += "<img class='device-icon' src='../../assets/img/specs/icons/tablet_icon_no.png' alt='not available on desktop' title='not available on tablet'>";
  }

  if (f.indexOf('M') > -1) {
    // add d
    block += "<img class='device-icon' src='../../assets/img/specs/icons/mobile_icon.png' alt='available on mobile' title='available on mobile'>";
  } else {
    block += "<img class='device-icon' src='../../assets/img/specs/icons/mobile_icon_no.png' alt='not available on desktop' title='not available on mobile'>";
  }

  block += "</div></div></div>";

  return block;
}

function showInfo(data) {
  const f = getNameFromUrl();
  formats = data.map(x => x[f]);
  const block = formats.reduce((total, format, index) => total + createAvailTile((index), format));
  const newBlock = block.substring(1);
  document.querySelector('.availability').innerHTML = newBlock;

  // hide loading
  document.querySelector('.loading').getElementsByTagName('img')[0].style.display = 'none';
}

function setupGrid() {
  const specCon = document.querySelector('.section-container');
  const grid = document.querySelector('.grid');
  const showcaseGrid = document.querySelector('.showcase-grid');

  bLazie = new Blazy();

  if (specCon) {
    document.querySelector('#avails').addEventListener('click', getAvailability);
    document.querySelector('#avails-but').addEventListener('click', getAvailability);

    const menuEl = document.getElementById('ml-menu');
    const mlmenu = new MLMenu(menuEl, {
      // breadcrumbsCtrl : true, // show breadcrumbs
      // initialBreadcrumb : 'all', // initial breadcrumb text
      backCtrl: true, // show back button
      // itemsDelayInterval : 60, // delay between each menu item sliding animation
      onItemClick: hideMenu // callback: item that doesn´t have a submenu gets clicked - onItemClick([event], [inner HTML of the clicked item])
    });

    // mobile menu toggle
    const openMenuCtrl = document.querySelector('.action--open');
    const closeMenuCtrl = document.querySelector('.action--close');

    openMenuCtrl.addEventListener('click', openMenu);
    closeMenuCtrl.addEventListener('click', closeMenu);

    const togs = document.getElementsByClassName('toggle');
    // togs.map(t => t.addEventListener('click', toggleDevice));
    for (var i = 0; i < togs.length; i++) {
      togs[i].addEventListener('click', toggleDevice);
    }

  } else if (grid) {

    // need to load all the new stories, inject the mark up then setup the slider

    // const slider = document.querySelector('.js_slider');

    // lory(slider, {
    //   infinite: 1
    // });

    var slidesToScroll = 1;
    var slider = document.querySelector('.js_slider');
    var slideCount = slider.querySelectorAll('.js_slide').length / slidesToScroll;
    var templateListItem = document.createElement('li');

    // http://stackoverflow.com/questions/19764018/controlling-fps-with-requestanimationframe
    var stop = false;
    var frameCount = 0;
    var fps, fpsInterval, startTime, now, then, elapsed;

    // handle the slider events
    function handleEvents(e) {
      if (e.type === 'before.lory.init') {
        for (var i = 0, len = slideCount; i < len; i++) {
          var clone = templateListItem.cloneNode();
        }
      }
      if (e.type === 'after.lory.init') {
        for (var i = 0, len = slideCount; i < len; i++) {

        }
      }
      if (e.type === 'after.lory.slide') {

      }
    }

    // init events to handle
    slider.addEventListener('before.lory.init', handleEvents);
    slider.addEventListener('after.lory.init', handleEvents);
    slider.addEventListener('after.lory.slide', handleEvents);

    // init the slider
    var lorySlider = lory(slider, {
      infinite: slidesToScroll,
      slidesToScroll: slidesToScroll,
      enableMouseEvents: true
    });

    // begin animation (autoplay)
    function startAnimating(fps) {
      fpsInterval = 1000 / fps;
      then = Date.now();
      startTime = then;
      animate();
    }

    // animate (autoplay)
    function animate() {
      requestAnimationFrame(animate);

      now = Date.now();
      elapsed = now - then;

      if (elapsed > fpsInterval && !stop) {
        then = now - (elapsed % fpsInterval);
        lorySlider.next();
      }
    }

    // reset timer
    function resetTimer() {
      now = Date.now();
      elapsed = now - then;
      then = now - (elapsed % fpsInterval);
    }

    // start the animation process with seed time
    startAnimating(.2); // every five seconds

    // mouseover 
    slider.addEventListener('mouseover', function (e) {
      stop = true;
    });

    // mouseout
    slider.addEventListener('mouseout', function (e) {
      resetTimer();
      stop = false;
    });

  } else if (showcaseGrid) {

    const iso = new Isotope('.showcase-grid', {
      // options...
      itemSelector: '.box',
      horizontalOrder: false,
      columnWidth: '.grid-sizer',
      getSortData: {
        number: function (item) {
          var number = $(item).attr('data-sort-by');
          return parseInt(number);
        }
      }

    });

    iso.once('layoutComplete', () => {
      bLazie.revalidate();
    })

    iso.layout();
  }
}

function start() {
  setupGrid();
}

function getAvailability() {
  // hide button
  document.querySelector('#avails-but').style.display = 'none';
  // show loading...
  document.querySelector('.loading').getElementsByTagName('img')[0].style.display = 'block';

  Tabletop.init({
    key: publicSpreadsheetUrl,
    callback: showInfo,
    simpleSheet: true
  });
}

// window.addEventListener('load', start);

start();



// WEBPACK FOOTER //
// ./app.js